$('form.account_recover').submit(async (e) => {
    e.preventDefault()

    /** Loading icon after click */
    $('.reset_submit').attr('disabled', 'true')
    $('.reset_submit span').addClass('d-none')
    $('.spinner').removeClass('d-none')
    

    /** Create form data */
    const formData = new FormData()
    formData.append('form_type', 'recover_customer_password')
    formData.append('utf8', '✓')
    formData.append('email', $('input#RecoverEmail').val())

    const response = fetch('/account/recover', {
        method: 'post',
        body: formData,
        redirect: "follow"
    })
    response
    .then( async res => {

        const textResponse = await res.text()
        const noAccountFound = textResponse.search('No account found with that email.')
        const checkIfExists = textResponse.search('Too many attempts: Please try again later.')

        if(checkIfExists > -1){
            /** Too many request */
            $('input#RecoverEmail').addClass('invalid--credentials')
            $('.attempt_error__message').removeClass('d-none')
            $('.reset_error__message').addClass('d-none')
            $('.reset_success__message').addClass('d-none')
        }else if(noAccountFound > -1){
            /** Email not exists */
            $('input#RecoverEmail').addClass('invalid--credentials')
            $('.reset_error__message').removeClass('d-none')
            $('.attempt_error__message').addClass('d-none')
            $('.reset_success__message').addClass('d-none')
        }else{
            /** Success */
            $('.attempt_error__message').addClass('d-none')
            $('.reset_error__message').addClass('d-none')
            $('.reset_success__message').removeClass('d-none')
        }
        /** Loading icon after click */
        $('.reset_submit').removeAttr('disabled')
        $('.reset_submit span').removeClass('d-none')
        $('.spinner').addClass('d-none')
    })
    return false
})